import {Item as DropdownItem} from '@wandb/weave/components/DropdownMenu';
import React, {type ReactNode} from 'react';

import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';

type RunRowHeaderOptionProps = {
  // The menu content is portaled outside the run selector's
  // data-dd-privacy="allow" container, so items need an explicit name to avoid
  // reporting as "Masked Element" in RUM.
  'data-dd-action-name'?: string;
  disabled?: boolean;
  icon: ReactNode;
  infoLabel?: ReactNode;
  label: ReactNode;
  onSelect: () => void;
};

export function RowHeaderMenuOption({
  'data-dd-action-name': ddActionName,
  disabled,
  icon,
  infoLabel,
  label,
  onSelect,
}: RunRowHeaderOptionProps) {
  return (
    <DropdownItem
      data-dd-action-name={ddActionName}
      // A registered action name means the element is static UI text,
      // so it's safe to unmask in session replay too.
      data-dd-privacy={ddActionName ? DD_PRIVACY_ALLOW : undefined}
      onSelect={onSelect}
      disabled={disabled}>
      <div className="flex flex-row items-center gap-8 grow">
        {icon}
        <div className="grow shrink">{label}</div>
        <div style={{color: disabled ? 'inherit' : 'var(--tertiary-text)'}}>
          {infoLabel}
        </div>
      </div>
    </DropdownItem>
  );
}
